module.exports = __webpack_public_path__ + "img/9788958288961.eaf401ea.jpg";